import { FileParams, FileSubjectTypes, FileTypes, PREVIEWABLE_TYPES } from "@/types/fileTypes";

export class File {
  static readonly MAX_FILE_NAME_LENGTH = 255;

  id: string;
  subjectId: string;
  subjectType: FileSubjectTypes;
  fileName: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  type: FileTypes;
  s3Url: string;
  pending: boolean;

  constructor(params: FileParams) {
    this.id = params.id;
    this.subjectId = params.subjectId;
    this.subjectType = params.subjectType;
    this.fileName = params.fileName;
    this.updatedAt = params.updatedAt;
    this.createdAt = params.createdAt;
    this.type = this.getFileTypeFromFile();
    this.s3Url = params.s3Url;
    this.pending = params.pending ?? false;
  }

  getFileTypeFromFile(): FileTypes {
    if (/\.(mp4|mov|webm|mkv)$/i.test(this.fileName)) return FileTypes.VIDEO;
    if (/\.(jpg|jpeg|png|gif|svg|webp|bmp)$/i.test(this.fileName)) return FileTypes.IMAGE;
    if (/\.pdf$/i.test(this.fileName)) return FileTypes.PDF;
    return FileTypes.GENERIC;
  }

  isReference() {
    return this.subjectType === FileSubjectTypes.CUSTOM_FIELD || this.subjectType === FileSubjectTypes.OBJECT_VALUE;
  }

  isPreviewable() {
    return PREVIEWABLE_TYPES.includes(this.type);
  }
}
